import axios from "axios";
import { Toast } from "../../util/Toast";
import {
  GET_FAMILY_CLAN_LEVEL,
  CREATE_NEW_FAMILY_CLAN_LEVEL,
  EDIT_FAMILY_CLAN_LEVEL,
  CLOSE_FAMILY_CLAN_LEVEL_DIALOG,
  DELETE_FAMILY_CLAN_LEVEL,
} from "./types";

export const getFamilyClanLevel = () => (dispatch) => {
  axios
    .get(`familyClanLevel`)
    .then((res) => {
      if (res.data.status) {
        console.log("Family Clan Level Data:", res.data.data);
        dispatch({ type: GET_FAMILY_CLAN_LEVEL, payload: res.data.data });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const createNewFamilyClanLevel = (data) => (dispatch) => {
  axios
    .post(`familyClanLevel`, data)
    .then((res) => {
      if (res.data.status) {
        Toast("success", "Family Clan Level created successfully!");
        dispatch({ type: CLOSE_FAMILY_CLAN_LEVEL_DIALOG });
        dispatch({
          type: CREATE_NEW_FAMILY_CLAN_LEVEL,
          payload: res.data.data,
        });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const editFamilyClanLevel = (familyClanLevelId, data) => (dispatch) => {
  axios
    .post(`familyClanLevel/${familyClanLevelId}`, data)
    .then((res) => {
      if (res.data.status) {
        Toast("success", "Family Clan Level updated successfully!");
        dispatch({ type: CLOSE_FAMILY_CLAN_LEVEL_DIALOG });
        dispatch({
          type: EDIT_FAMILY_CLAN_LEVEL,
          payload: { data: res.data.data, id: familyClanLevelId },
        });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const deleteFamilyClanLevel = (familyClanLevelId) => (dispatch) => {
  axios
    .delete(`familyClanLevel/${familyClanLevelId}`)
    .then((res) => {
      if (res.data.status) {
        Toast("success", "Family Clan Level deleted successfully!");
        dispatch({
          type: DELETE_FAMILY_CLAN_LEVEL,
          payload: familyClanLevelId,
        });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => console.log(error));
};
